import PageValidState from '../../Shared/pageValidState';
import { WorkflowEngineState } from '../workflowEngineReducer';

export default (state: WorkflowEngineState, newPage: PageValidState) => {
  const updatedArray = state.pagesValidState.map((page) =>
    page.id === newPage.id ? newPage : page
  );
  return { ...state, pagesValidState: updatedArray };
};
